import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderTopbar from "../HeaderTopbar/HeaderTopbar";
import MobileMenu from "../MobileMenu/MobileMenu";
import { getBusinessSettings } from "../../api/getBusinessSettings";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getProjects } from "../../api/project";

const Header2 = (props) => {
  const [menuActive, setMenuState] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // current input value
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
  const [categories, setCategories] = useState([]);

  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);

  useEffect(() => {
    getProjects().then((data) => {
      setProjects(data);
      setLoadingProjects(false);
    });
  }, []);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [settings, setSettings] = useState(null);

  useEffect(() => {
    getBusinessSettings().then(setSettings);
  }, []);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/pro-categ-name`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        setCategories(res.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    getCategories();
  }, []);

  if (!settings) return null;

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/service" },
    { label: "Products", path: "/product" },
    { label: "Projects", path: "/project" },
    { label: "Events", path: "/event" },
    { label: "Contact", path: "/contact" },
    { label: "Team", path: "/team" },
    { label: "Our Business", path: "/business" },
  ];

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.length > 0) {
      const filtered = navItems.filter((item) =>
        item.label.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (path) => {
    setSearchTerm("");
    setSuggestions([]);
    navigate(path);
  };

  return (
    <header id="header" className={props.topbarNone}>
      <HeaderTopbar />
      <div className={`wpo-site-header ${props.hclass}`}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <div className="mobail-menu">
                  <MobileMenu />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6">
                <div
                  className="navbar-header"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Link onClick={ClickHandler} className="navbar-brand" to="/">
                    <img
                      src={`${apiUrl}/storage/` + settings.logo}
                      alt=""
                      style={{
                        width: "100px",
                        height: "60px",
                        display: "block",
                        margin: "auto",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                        borderRadius: "5px",
                      }}
                    />
                  </Link>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-1 col-1"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flex: "4",
                }}
              >
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/about">
                        About Us
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/about">
                            About
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/team">
                            Team
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/business">
                            Our Business
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/service">
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/product">
                        Products
                      </Link>
                      <ul className="sub-menu">
                        {categories.map((c, index) => (
                          <li key={index}>
                            <Link
                              onClick={ClickHandler}
                              to={`/product?category_id=${
                                c.id
                              }&category_name=${encodeURIComponent(c.name)}`}
                            >
                              {c.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    {!loadingProjects && projects.length > 0 && (
                      <li className="menu-item-has-children">
                        <Link onClick={ClickHandler} to="/project">
                          Projects
                        </Link>
                      </li>
                    )}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/event">
                        Events
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-2 col-2"
                style={{
                  flex: "1",
                }}
              >
                <div className="header-right">
                  <div className="header-search-form-wrapper">
                    <div className="cart-search-contact">
                      <button
                        onClick={() => setMenuState(!menuActive)}
                        className="search-toggle-btn"
                      >
                        <i
                          className={`fi ti-search ${
                            menuActive ? "ti-close" : "fi "
                          }`}
                        ></i>
                      </button>
                      <div
                        className={`header-search-form ${
                          menuActive ? "header-search-content-toggle" : ""
                        }`}
                      >
                        <form onSubmit={SubmitHandler}>
                          <div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search here..."
                              value={searchTerm}
                              onChange={handleSearchChange}
                            />
                            {suggestions.length > 0 && (
                              <ul
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  right: 0,
                                  background: "white",
                                  border: "1px solid #ccc",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  zIndex: 999,
                                  listStyle: "none",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                {suggestions.map((item, index) => (
                                  <li
                                    key={index}
                                    onClick={() =>
                                      handleSuggestionClick(item.path)
                                    }
                                    style={{
                                      padding: "8px 12px",
                                      cursor: "pointer",
                                      borderBottom: "1px solid #eee",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.background = "#4aa3ff"; // your hover background
                                      e.target.style.color = "#fff"; // text becomes white
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.background = "#fff"; // back to original background
                                      e.target.style.color = "#000"; // back to black text
                                    }}
                                  >
                                    {item.label}
                                  </li>
                                ))}
                              </ul>
                            )}
                            <button type="submit">
                              <i className="fi flaticon-search-interface-symbol"></i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div className="close-form">
                    <Link
                      onClick={ClickHandler}
                      to="/contact"
                      style={{
                        background: "linear-gradient(90deg, #001f5b, #007bff)", // dark blue → light blue
                        color: "white",
                        padding: "10px 15px",
                        borderRadius: "20px",
                        textDecoration: "none",
                        fontWeight: "600",
                        transition: "all 0.3s ease",
                        display: "inline-block",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                          "0 6px 15px rgba(0, 0, 0, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                          "0 4px 10px rgba(0, 0, 0, 0.3)";
                      }}
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header2;
